<template>
  <div class="auth-form">
    <p class="auth-lead mb-3">E-mail k účtu</p>
    <argon-alert
      v-for="message in store.state.alert.message"
      :key="message"
      v-show="store.state.alert.type == 'danger'"
      class="text-sm text-center mb-3"
      color="danger"
      icon="fa-solid fa-triangle-exclamation"
    >
      {{ message }}
    </argon-alert>
    <form @submit.prevent="resetPassword">
      <div class="mb-3">
        <input
          class="form-control form-control-lg"
          type="email"
          ref="autofocus"
          v-model="email"
          placeholder="E-mail"
          name="email"
          autocomplete="username"
          required
        />
      </div>
      <argon-button
        class="mt-2"
        color="primary"
        size="lg"
        :disabled="isButtonLoading"
        fullWidth
      >
        <span v-if="isButtonLoading" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
        Obnovit heslo
      </argon-button>
    </form>
    <div class="pt-3 text-center">
      <p class="mx-auto mb-0 text-sm">
        <a
          href="javascript:;"
          class="text-primary font-weight-bolder"
          @click="store.state.showForm = 'login'"
        >Zpět k přihlášení</a>
      </p>
    </div>
  </div>
</template>

<script setup>
import { ref, inject, computed, nextTick, onMounted } from "vue";
import { useStore } from "vuex";
import ArgonButton from "@/components/ArgonButton.vue";
import ArgonAlert from "@/components/ArgonAlert.vue";
import authService from "@/services/authService";

const store = useStore();
const swal = inject('$swal');

const autofocus = ref();
const email = ref('');
const isButtonLoading = computed(() => store.getters['loadingModule/isButtonLoading']);

const resetPassword = async () => {
  try {
    store.dispatch('loadingModule/setButtonLoading', true);
    const response = await authService.UserPasswordReset(email.value)

    if (response.Result) {
      store.dispatch('toggleAuthModal');
      swal.fire({
        position: 'center',
        icon: 'success',
        width: '35rem',
        html: `${response.InfoMessage.map(message => `<h5 class="text-center">${message}</h5>`).join('')}`,
        showConfirmButton: false,
        timer: 3000,
      })
    } else {
      store.dispatch('alertError', response.ErrorMessage);
      nextTick(() => {
        email.value = '';
        autofocus.value.focus();
      })
    }
  } catch (error) {
    console.error(error);
  } finally {
    store.dispatch('loadingModule/setButtonLoading', false);
  }
}

onMounted(() => {
  nextTick(() => {
    autofocus.value.focus();
  })
});
</script>

<style scoped>
.auth-lead {
  margin: 0;
  font-size: 0.88rem;
  font-weight: 600;
  color: #64748B;
}
</style>
